import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesCallsPage, { type CallsSearch } from '../../views/dashboard-voice-sales/CallsPage';

const CALL_SORT_FIELDS = new Set(['started', 'duration', 'status', 'campaign']);

function stringSearchValue(value: unknown): string | undefined {
  if (typeof value === 'string' && value) return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return undefined;
}

export const Route = createFileRoute('/dashboard/voice-sales/calls')({
  validateSearch: (input: Record<string, unknown>): CallsSearch => ({
    q: stringSearchValue(input.q),
    campaign: stringSearchValue(input.campaign),
    status: stringSearchValue(input.status),
    sortingField:
      typeof input.sortingField === 'string' && CALL_SORT_FIELDS.has(input.sortingField)
        ? (input.sortingField as CallsSearch['sortingField'])
        : undefined,
    sortDirection: input.sortDirection === 'asc' || input.sortDirection === 'desc' ? input.sortDirection : undefined,
    page: Number.isInteger(Number(input.page)) && Number(input.page) > 1 ? Number(input.page) : undefined,
  }),
  component: VoiceSalesCallsPage,
});
